<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="8"
          md="8"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="4"
          md="4"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="filter"
              class="d-inline-block mr-1"
              :placeholder="$t('Search...')"
              type="search"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      :items="regulatoryLimitList"
      responsive
      :busy="isBusy"
      :fields="translatedTableHeaders"
      :filter="filter"
      :filter-included-fields="filterOn"
      filter-debounce="100"
      show-empty
      :empty-text="$t('No records available')"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      class="position-relative"
      @filtered="onFiltered"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BSpinner,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance } from '../../../../../helpers/formatAmount'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BSpinner,
    TablePagination,
    TableEntries,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      sortBy: 'name',
      required,
      filterOn: [],
      filter: null,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'countryCode', sortable: true, label: 'Country Code' },
        { key: 'atM_Single_Withdrawal_Limit', sortable: true, label: 'ATM Single Withdrawal Limit' },
        { key: 'atM_Daily_Withdrawal_Limit', sortable: true, label: 'ATM Daily Withdrawal Limit' },
        { key: 'atM_Weekly_Withdrawal_Limit', sortable: true, label: 'ATM Weekly Withdrawal Limit' },
        { key: 'poS_Daily_Withdrawal_Limit', sortable: true, label: 'POS Daily Withdrawal Limit' },
        { key: 'poS_Weekly_Withdrawal_Limit', sortable: true, label: 'POS Weekly Withdrawal Limit' },
      ],
      regulatoryLimitList: [],
    }
  },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    this.fetchRegulatoryLimits()
  },
  methods: {
    ...mapActions({
      getRegulatoryLimits: 'eChannels/getRegulatoryLimitsList',
    }),

    async fetchRegulatoryLimits() {
      try {
        this.isBusy = true
        const response = await this.getRegulatoryLimits({
          search: '',
          page: this.currentPage,
          limit: this.perPage,
          permission: 'VIEW_REGULATORY_LIMIT',
        })
        const { status, data } = response
        if (status === 200 && data.data !== null) {
          this.regulatoryLimitList = data.data.map(item => ({
            ...item,
            atM_Daily_Withdrawal_Limit: toBalance(item.atM_Daily_Withdrawal_Limit),
            atM_Single_Withdrawal_Limit: toBalance(item.atM_Single_Withdrawal_Limit),
            atM_Weekly_Withdrawal_Limit: toBalance(item.atM_Weekly_Withdrawal_Limit),
            poS_Daily_Withdrawal_Limit: toBalance(item.poS_Daily_Withdrawal_Limit),
            poS_Weekly_Withdrawal_Limit: toBalance(item.poS_Weekly_Withdrawal_Limit),
          }))
          this.totalCount = data.recordCount
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalCount = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
